import React, { useState } from "react";
import styled from "styled-components";
import { Spinner, Table as BsTable } from "react-bootstrap";
import { ItemListadoAsistenciaDiaria } from "../../../services/asistenciaServicios";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import IconContainer from "../../organisms/IconContainer";

function Table({
  items,
  isLoading,
  isSuccess,
  onAsistioChange,
  onReagendarClick,
}: {
  items: ItemListadoAsistenciaDiaria[];
  isLoading: boolean;
  isSuccess: boolean;
  onAsistioChange: (payload: { id: string; asistio: boolean }) => void;
  onReagendarClick: (item: ItemListadoAsistenciaDiaria) => void;
}) {
  return (
    <StyledTable responsive hover>
      <thead>
        <tr>
          <StyledColHeader>No.</StyledColHeader>
          <StyledColHeader>Mascota</StyledColHeader>
          <StyledColHeader>Propietario</StyledColHeader>
          <StyledColHeader>Raza</StyledColHeader>
          <StyledColHeader>Tipo Reserva</StyledColHeader>
          <StyledColHeader>Ingresó</StyledColHeader>
          <StyledColHeader></StyledColHeader>
        </tr>
      </thead>
      <tbody>
        {isLoading && <LoadingItem />}
        {isSuccess &&
          items.map((_, i) => (
            <TableItem
              key={_.idMascota}
              item={_}
              no={i + 1}
              onAsistioChange={onAsistioChange}
              onReagendarClick={onReagendarClick}
            />
          ))}
      </tbody>
    </StyledTable>
  );
}

function TableItem({
  no,
  item,
  onAsistioChange,
  onReagendarClick,
}: {
  no: number;
  item: ItemListadoAsistenciaDiaria;
  onAsistioChange: (payload: { id: string; asistio: boolean }) => void;
  onReagendarClick: (item: ItemListadoAsistenciaDiaria) => void;
}) {
  const [currentItem, setCurrentItem] = useState(item);

  const onIncresoToggle = (asistio: boolean) => {
    setCurrentItem((prevItem) => {
      const newItem: ItemListadoAsistenciaDiaria = {
        ...prevItem,
        asistio,
      };
      return newItem;
    });

    onAsistioChange({ id: item.id, asistio });
  };

  return (
    <DynamicRow isSuccess={currentItem.asistio}>
      <StyledCell>{no}</StyledCell>
      <StyledCell>{item.nombreMascota}</StyledCell>
      <StyledCell>{item.nombrePropietario}</StyledCell>
      <StyledCell>{item.raza}</StyledCell>
      <StyledCell>{calcularTipoReserva(item)}</StyledCell>
      <StyledCell>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            checked={currentItem.asistio}
            id="flexCheckDefault"
            onChange={() => {
              onIncresoToggle(!currentItem.asistio);
            }}
          />
        </div>
      </StyledCell>
      <ReagendamientoColumn
        item={currentItem}
        onReagendarClick={onReagendarClick}
      />
    </DynamicRow>
  );
}

type TipoReserva = "Guardería" | "Hotel";

function calcularTipoReserva(item: ItemListadoAsistenciaDiaria): TipoReserva {
  if (item.idReservaGuarderia) {
    return "Guardería";
  }
  if (item.idReservaHotel) {
    return "Hotel";
  }

  throw Error(
    "Item de asistencia debe tener idReservaGuarderia o idReservaHotel"
  );
}

function ReagendamientoColumn({
  item,
  onReagendarClick,
}: {
  item: ItemListadoAsistenciaDiaria;
  onReagendarClick: (item: ItemListadoAsistenciaDiaria) => void;
}) {
  const onButtonClick = () => {
    onReagendarClick(item);
  };

  if (item.asistio) {
    return <StyledCell />;
  } else {
    return (
      <StyledCell>
        <IconContainer onClick={onButtonClick} style={{ cursor: "pointer" }}>
          <EventRepeatIcon />
        </IconContainer>
      </StyledCell>
    );
  }
}

function LoadingCell() {
  return (
    <StyledCell>
      <Spinner animation={"border"} />
    </StyledCell>
  );
}

function LoadingItem() {
  return (
    <StyledRow>
      <LoadingCell />
      <LoadingCell />
      <LoadingCell />
      <LoadingCell />
      <LoadingCell />
      <LoadingCell />
      <LoadingCell />
    </StyledRow>
  );
}

function DynamicRow({
  children,
  isSuccess,
}: {
  children: React.ReactNode;
  isSuccess: boolean;
}) {
  if (isSuccess) {
    return <StyledSuccessRow>{children}</StyledSuccessRow>;
  } else {
    return <StyledRow>{children}</StyledRow>;
  }
}

const StyledTable = styled(BsTable)``;

const StyledCell = styled("td")``;

const StyledColHeader = styled("th")`
  color: ${(props) => props.theme.colors.main};
`;

const StyledRow = styled("tr")`
  cursor: pointer;
`;

const StyledSuccessRow = styled(StyledRow)`
  background-color: ${(props) => props.theme.colors.successShadow};
`;

export default Table;
